import React from "react";
import classnames from "classnames";
import PropTypes from "prop-types";

const TaskTableRow = ({ taskNumber, name, oldDate, newDate, isCompleted }) => {
  const taskNameClass = classnames("col_name", {
    completed_dependency: isCompleted,
  });

  return (
    <tr>
      <td className={taskNameClass}>
        #{taskNumber}: {name}
      </td>
      <td className="col_date_old">{oldDate}</td>
      <td className="col_arrow">
        <span className="arrow icon size_20 icon_arrow_right_grey" />
      </td>
      <td className="col_date_new">{newDate}</td>
    </tr>
  );
};

TaskTableRow.displayName = "TaskTableRow";

TaskTableRow.propTypes = {
  taskNumber: PropTypes.number,
  name: PropTypes.string,
  oldDate: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  newDate: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  isCompleted: PropTypes.bool,
};

TaskTableRow.defaultProps = {
  isCompleted: false,
};

export default TaskTableRow;
